module.exports = require("react-keyboard-shortcuts");